import axios from "axios";
import backendUrl from "./constant/backendUrl";
/* export async function getAgents(){
    const url = `${backendUrl}/Agent/GetAgentsByAgency?agencyId=1`;
      return await axios.get(url)
  
    } */

export async function insertReferral(formData, queryParams=""){
    let url = `${backendUrl}/Referral?${queryParams}`;
   return  axios.post(url, formData)
}
